import { Logo } from './logo';
import { Button } from './ui/button';

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative h-screen flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0 bg-background text-foreground">
      <div className="relative hidden h-full flex-col p-10 text-primary-foreground dark:border-r lg:flex">
        <div className="absolute inset-0 bg-foreground bg-[radial-gradient(66.84%_77.34%_at_8.4%_7.88%,_rgba(7,_0,_24,_80%)_20%,hsla(241.3_87.62%_58.82%/20%)_100%)] dark:bg-background dark:bg-[radial-gradient(90.84%_87.34%_at_8.4%_7.88%,_rgba(25,_6,_72,_50%)_20%,hsla(241.3_92%_66%/80%)_100%)]"></div>

        <div className="relative z-20 flex items-center text-lg font-medium">
          <Logo className="w-36" />
        </div>

        <div className="relative z-20">
          <h1 className="mt-14 font-['Be_Vietnam_Pro'] text-[56px] font-bold leading-tight">
            Unlock learning in
            <br />
            your product.
          </h1>

          <p className="mt-4 font-['Be_Vietnam_Pro'] text-3xl font-extralight leading-tight">
            With AI and data, you can provide embedded, curated learning to:
          </p>

          <h2 className="mt-4 font-['Be_Vietnam_Pro'] font-extralight leading-loose">
            &bull; Decrease the number of help requests
            <br />
            &bull; Lessen the pressure on customer education resources
            <br />
            &bull; Enhance your product and learning materials
          </h2>

          <h3 className="mt-24 font-['Be_Vietnam_Pro'] text-sm font-bold">Interested?</h3>
          <div className="mt-2 font-['Be_Vietnam_Pro'] text-sm">
            We are currently offering preview access to customers
            <div className="mt-4">
              <Button variant="secondary" asChild>
                <a
                  href="https://airtable.com/appI6emrlK54BPEru/pagUfKpUQGkDcQaeV/form"
                  target="_blank"
                  rel="noreferrer"
                  className="font-['Be_Vietnam_Pro'] text-xs">
                  Request an access code
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex h-full items-center p-4 lg:p-8">
        <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
          {children}
        </div>
      </div>
    </div>
  );
}
